// What the signed-in person may open and do: the permissions their session holds (/auth/session), the
// union of every role they hold, a company's own roles included, and a grant from before roles (BL-137).
// Places and controls ask for the permission their action needs, never a role name, so a role the owner
// cloned or made opens what it gives (QA-680, QA-681). The server checks every call again.

/** Whether the person holds any of these permissions. */
export const holdsAny = (held: readonly string[] | undefined, any: readonly string[]): boolean =>
  !!held && any.some((p) => held.includes(p));
